import React, { SVGProps } from 'react';
const notesFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M4 24h16v-2.667H4zM4 8v2.667h24V8zm0 9.333h24v-2.667H4z" /></svg>;
export default notesFilled;